import withController from 'components/common/form-controlled/with-controller.hoc';
import withLabel from 'components/common/form-controlled/with-label.hoc';
import withTooltip from 'components/common/form-controlled/with-tooltip.hoc';
import type { CustomSelectProps } from 'components/common/input-components/select';
import Select from 'components/common/input-components/select';

export default withLabel(withController<CustomSelectProps>(withTooltip(Select)));
